import { createContext, type FC, type ReactNode, useContext } from "react";
import type { AccountLimitTypeMap } from "../generic/hooks/use-account-limit";

const AccountLimitContext = createContext<AccountLimitTypeMap | null>(null);

type AccountLimitProviderProps = {
  limits: AccountLimitTypeMap;
  children: ReactNode;
};

export const AccountLimitProvider: FC<AccountLimitProviderProps> = ({ limits, children }) => {
  return <AccountLimitContext.Provider value={limits}>{children}</AccountLimitContext.Provider>;
};

export const useAccountLimitsContext = (): AccountLimitTypeMap => {
  const context = useContext(AccountLimitContext);
  if (!context) {
    throw new Error("useAccountLimitsContext must be used within an AccountLimitProvider");
  }
  return context;
};
